
let list = function(startDate, endDate) {
    return new Promise(function(resolve, reject) {
        const hash = localStorage.getItem('hash');
        let filterDate = "";

        if (startDate && endDate)
            filterDate = "?start_date=" + startDate + "&end_date=" + endDate

        fetch(global.route.lead + filterDate, {
            headers: {'x-access-token': hash},
            method: 'GET'
        })
            .then((response) => (response.status !== 500) ? response.json() : global.printError(response))
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                console.log('lead list', responseJson);
                // if (remarketing) {
                //     if (responseJson.status === "LIST_LEADS_REMARKETING")
                //         resolve(responseJson.list);
                //     else
                //         reject(responseJson);
                // } else {
                    if (responseJson.status === "LIST_LEADS")
                        resolve(responseJson);
                    else
                        reject(responseJson);
                // }
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

// Ricerca sul server in TUTTI i lead, senza periodo: telefono (scritto in qualunque modo), email o
// nome. Torna la risposta intera: `list` e `search` ({q, limit, truncated}).
let search = function(q) {
    return new Promise(function(resolve, reject) {
        const hash = localStorage.getItem('hash');
        fetch(global.route.lead + "?q=" + encodeURIComponent(q), {
            headers: {'x-access-token': hash},
            method: 'GET'
        })
            .then((response) => (response.status !== 500) ? response.json() : global.printError(response))
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                if (responseJson.status === "LIST_LEADS")
                    resolve(responseJson);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

let detail = function(id) {
    return new Promise(function(resolve, reject) {
        const hash = localStorage.getItem('hash');
        fetch(global.route.lead + "/" + id, {
            headers: {'x-access-token': hash},
            method: 'GET'
        })
            .then((response) => (response.status !== 500) ? response.json() : global.printError(response))
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                console.log('lead detail', responseJson);
                if (responseJson.status === "LEAD_DETAIL_OK")
                    resolve(responseJson.lead);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

let add = function(lead) {
    return new Promise(function(resolve, reject) {
        const hash = localStorage.getItem('hash');
        fetch(global.route.lead, {
            headers: {
                'x-access-token': hash,
                'Content-Type': 'application/json'
            },
            method: 'PUT',
            body: JSON.stringify({
                name: lead.name,
                email: lead.email.toLowerCase(),
                phone: lead.phone,
                referral: lead.referral,
                module_id: lead.module_id
            })
        })
            .then((response) => (response.status !== 500) ? response.json() : global.printError(response))
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                console.log('lead add', responseJson);
                if (responseJson.status === "LEAD_CREATED")
                    resolve(responseJson.lead);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

// TODO morto: global.route.leadAddMultiple non e' definito in routesAPI.js e non
// esiste una route backend per l'inserimento multiplo lead. Se questa feature
// serve, aggiungere la chiave routesAPI + la route PUT /lead/multiple lato API.
// Lasciato per non rompere import/export esistenti.
let addMultiple = function(leads) {
    return new Promise(function(resolve, reject) {
        const hash = localStorage.getItem('hash');
        fetch(global.route.leadAddMultiple, {
            headers: {
                'x-access-token': hash,
                'Content-Type': 'application/json'
            },
            method: 'PUT',
            body: JSON.stringify({leads: leads})
        })
            .then((response) => (response.status !== 500) ? response.json() : global.printError(response))
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                console.log('lead multiple add', responseJson);
                if (responseJson.status === "LEADS_CREATED")
                    resolve(responseJson);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

let upload = function(file, module_id) {
    return new Promise(function(resolve, reject) {
        const hash = localStorage.getItem('hash');

        fetch(global.route.leadUpload + "/" + module_id, {
            headers: {
                'x-access-token': hash
            },
            method: 'PUT',
            body: file
        })
            .then((response) => (response.status !== 500) ? response.json() : global.printError(response))
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                console.log('lead upload', responseJson);
                if (responseJson.status === "LEADS_IMPORT_OK")
                    resolve(responseJson);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

let assign = function(assign) {
    return new Promise(function(resolve, reject) {
        const hash = localStorage.getItem('hash');

        fetch(global.route.leadAssign, {
            headers: {
                'x-access-token': hash,
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify({
                id_consulent: assign.id_consulent,
                id_leads: assign.id_leads
            })
        })
            .then((response) => (response.status !== 500) ? response.json() : global.printError(response))
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                console.log('lead assign', responseJson);
                if (responseJson.status === "LEAD_ASSIGNED")
                    resolve(responseJson);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

let assignGroup = function(payload) {
    return new Promise(function(resolve, reject) {
        const hash = localStorage.getItem('hash');

        fetch(global.route.leadAssignGroup, {
            headers: {
                'x-access-token': hash,
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify({
                id: payload.id,
                id_group: payload.id_group
            })
        })
            .then((response) => (response.status !== 500) ? response.json() : global.printError(response))
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                console.log('lead assign group', responseJson);
                if (responseJson.status === "LEAD_EDITED")
                    resolve(responseJson);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

/**
 * Trova/crea il lead CLTV per email+telefono. La usa la pagina embed "assegna-classe"
 * (azione personalizzata da ATOM) per sapere su quale lead scrivere, prima di mostrare
 * classi e lezioni di prova.
 */
let match = function(dati) {
    return new Promise(function(resolve, reject) {
        const hash = localStorage.getItem('hash');
        fetch(global.route.leadMatch, {
            headers: {
                'x-access-token': hash,
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify({
                email: dati.email,
                phone: dati.phone,
                name: dati.name
            })
        })
            .then((response) => (response.status !== 500) ? response.json() : global.printError(response))
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                if (responseJson.status === "LEAD_MATCHED")
                    resolve(responseJson);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

let edit = function(lead) {
    return new Promise(function(resolve, reject) {
        const hash = localStorage.getItem('hash');
        fetch(global.route.lead, {
            headers: {
                'x-access-token': hash,
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify({
                id: lead.id,
                name: lead.name,
                email: lead.email,
                phone: lead.phone,
                country: lead.country
            })
        })
            .then((response) => (response.status !== 500) ? response.json() : global.printError(response))
            .then((responseJson) => {
                 global.checkAuth(responseJson.status);
                console.log('lead edit questions', responseJson);
                if (responseJson.status === "LEAD_EDITED")
                    resolve(responseJson);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

let editStatus = function(id, status) {
    return new Promise(function(resolve, reject) {
        const hash = localStorage.getItem('hash');
        fetch(global.route.leadStatus, {
            headers: {
                'x-access-token': hash,
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify({
                id: id,
                status: status
            })
        })
            .then((response) => (response.status !== 500) ? response.json() : global.printError(response))
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                console.log('lead edit status', responseJson);
                if (responseJson.status === "LEAD_STATUS_CHANGED")
                    resolve(responseJson);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

let editQuestion = function(id, details) {
    return new Promise(function(resolve, reject) {
        const hash = localStorage.getItem('hash');
        fetch(global.route.leadQuestion, {
            headers: {
                'x-access-token': hash,
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify({
                id: id,
                details: details
            })
        })
            .then((response) => (response.status !== 500) ? response.json() : global.printError(response))
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                console.log('lead edit questions', responseJson);
                if (responseJson.status === "LEAD_EDITED")
                    resolve(responseJson);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

let close = function(lead) {
    return new Promise(function(resolve, reject) {
        const hash = localStorage.getItem('hash');
        fetch(global.route.leadClose, {
            headers: {
                'x-access-token': hash,
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify({
                id: lead.id,
                note: lead.note
            })
        })
            .then((response) => (response.status !== 500) ? response.json() : global.printError(response))
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                console.log('lead close', responseJson);
                if (responseJson.status === "LEAD_CLOSED")
                    resolve(responseJson);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

let remove = function(id) {
    return new Promise(function(resolve, reject) {
        const hash = localStorage.getItem('hash');
        fetch(global.route.lead, {
            headers: {
                'x-access-token': hash,
                'Content-Type': 'application/json'
            },
            method: 'DELETE',
            body: JSON.stringify({
                id: id
            })
        })
            .then((response) => (response.status !== 500) ? response.json() : global.printError(response))
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                console.log('lead delete', responseJson);
                if (responseJson.status === "LEAD_DELETED")
                    resolve(responseJson.lead);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};


const LeadAPI = {
    list: list,
    search: search,
    detail: detail,
    upload: upload,
    add: add,
    addMultiple: addMultiple,
    edit: edit,
    editStatus: editStatus,
    assignGroup: assignGroup,
    match: match,
    editQuestion: editQuestion,
    assign: assign,
    close: close,
    remove: remove
};

module.exports = LeadAPI;
